import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=2e3f4901&"
import script from "./CompanyInfo.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3f4901')) {
      api.createRecord('2e3f4901', component.options)
    } else {
      api.reload('2e3f4901', component.options)
    }
    module.hot.accept("./CompanyInfo.vue?vue&type=template&id=2e3f4901&", function () {
      api.rerender('2e3f4901', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CompanyInfo.vue"
export default component.exports